/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, Input } from '@angular/core';
import { ReportingSharedService } from '../reporting-shared.service';

//TODO rename to iriro-reporting-shared
@Component({
  selector: 'iric-reporting-shared, iriro-reporting-shared',
  templateUrl: './reporting-shared.component.html',
  styleUrls: ['./reporting-shared.component.scss'],
})
export class ReportingSharedComponent {
  @Input() label: string | undefined = undefined;
  @Input() reportRef: string | undefined = undefined;
  @Input() params: {
      parameterName: string;
      parameterLabel: string;
      parameterValue: string;
      parameterValueLabel: string;
    }[] | undefined = undefined;

  constructor(private readonly reportingSharedService: ReportingSharedService) {}

  download() {
    this.reportingSharedService.downloadGeneratedSnapshotReport(this.reportRef, this.params);
  }
}
